var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickOutlines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8031 12.5958C30.1322 12.1523 30.0394 11.526 29.5958 11.1969C29.1523 10.8678 28.526 10.9606 28.1969 11.4042L17.3875 25.9733L10.7071 19.2929C10.3166 18.9024 9.68342 18.9024 9.29289 19.2929C8.90237 19.6834 8.90237 20.3166 9.29289 20.7071L16.7929 28.2071C16.9985 28.4127 17.2835 28.5186 17.5735 28.4973C17.8635 28.4759 18.1298 28.3294 18.3031 28.0958L29.8031 12.5958Z",
    fill: "#23756B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20ZM38 20C38 29.9411 29.9411 38 20 38C10.0589 38 2 29.9411 2 20C2 10.0589 10.0589 2 20 2C29.9411 2 38 10.0589 38 20Z",
    fill: "#23756B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickOutlines);
export default __webpack_public_path__ + "static/media/Tick_Outlines.5872c98e44cbd608ed6a770c04f1f672.svg";
export { ForwardRef as ReactComponent };